import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  transformFromNumberToString,
  transformFromStringToNumber,
} from 'components/modules/Insurance/Insurance.helpers';
import { setCarInstance, updateErrors } from 'store/carInstance/actions';
import { selectErrors, selectHidden, selectValues } from 'store/carInstance/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './MileageInput.constants';

export const useMileageInputPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: error } = useSelector(selectErrors);
  const { [NAME]: value } = useSelector(selectValues);
  const { [NAME]: hidden } = useSelector(selectHidden);

  const { disabled: pageRestrict } = useDisabledFields();

  const onChange = useCallback(({ [NAME]: value }) => {
    dispatch(setCarInstance({ [NAME]: transformFromStringToNumber(value) || undefined }));
    dispatch(updateErrors({ [NAME]: '' }));
  }, []);

  return {
    disabled: pageRestrict,
    error,
    hidden,
    onChange,
    value: transformFromNumberToString(value),
  };
};
